import { AnalyzeRoutes } from '@/features/analyze/routes';
import { BookmarkRoutes } from '@/features/bookmark/routes';
import { SavedFilterAlertRoutes } from '@/features/saved-filter-alert';
import { SettingsRoutes } from '@/features/settings/routes';
import { SetupRoutes } from '@/features/setup/routes';
import { SubscriptionRoutes } from '@/features/subscription/routes';
import { ThemeRoutes } from '@/features/theme/routes';
import { OrganizationsRoutes } from '@/features/organizations/routes';
import { PrivateApp } from '@/routes/PrivateApp';

export const PRIVATE_TOP_PATH = '/themes';

export const privateRoutes = [
  {
    element: <PrivateApp />,
    children: [
      { path: `${PRIVATE_TOP_PATH}/*`, element: <ThemeRoutes /> },
      { path: '/saved-filter-alerts/*', element: <SavedFilterAlertRoutes /> },
      { path: '/analyze/*', element: <AnalyzeRoutes /> },
      { path: '/setup/*', element: <SetupRoutes /> },
      { path: '/settings/*', element: <SettingsRoutes /> },
      { path: '/subscription/*', element: <SubscriptionRoutes /> },
      { path: '/bookmark/*', element: <BookmarkRoutes /> },
      { path: '/organizations/*', element: <OrganizationsRoutes /> },
    ],
  },
];
